import constant from "./constant";

let sharedInfo = {};

const safeLocalStorage =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
    ? window.localStorage
    : null;

export const setSharedInfo = (key, data) => {
  if (key) sharedInfo[key] = data;
};

export const getSharedInfo = (key) => {
  return sharedInfo[key];
};

export const clearSharedInfo = (key) => {
  sharedInfo[key] = null;
};

export const setStorageData = (key, url) => {
  if (safeLocalStorage) {
    safeLocalStorage.setItem(key, url);
  }
};

export const getStorageData = (key) => {
  if (safeLocalStorage) {
    return safeLocalStorage.getItem(key);
  }
};

export const clearStorage = (key = "") => {
  if (safeLocalStorage) {
    if (key) {
      safeLocalStorage.removeItem(key);
    } else {
      safeLocalStorage.clear();
    }
  }
};

export const setZohoRedirectUrl = (url) => {
  setStorageData(constant.zohoRedirect, url);
};

export const getZohoRedirectUrl = () => {
  return getStorageData(constant.zohoRedirect);
};

export const clearZohoRedirectUrl = () => {
  if (safeLocalStorage) {
    return safeLocalStorage.getItem(constant.zohoRedirect);
  }
};
